import { Component } from "react";

interface MemoryBarProps {
  vram: number; // VRAM used
  total: number; // total model size
}

export class MemoryBar extends Component<MemoryBarProps> {
  render() {
    const { vram, total } = this.props;
    const usedPercentage = (vram / total) * 100;
    const clampedUsed = Math.min(100, Math.max(0, usedPercentage));
    const freePercentage = 100 - clampedUsed;

    let hint = `VRAM: ${(vram / (1024 * 1024 * 1024)).toFixed(2)} Gb used, ${clampedUsed.toFixed(0)}%`;
    if (vram < total) {
      hint += ` of total ${(total / (1024 * 1024 * 1024)).toFixed(2)} Gb`;
    }

    return (
      <div className="memory-bar" title={hint}>
        <div
          className="memory-used"
          style={{ width: `${clampedUsed}%` }}
        />
        <div
          className="memory-free"
          style={{ width: `${freePercentage}%` }}
        />
      </div>
    );
  }
}